import { createFileRoute } from '@tanstack/react-router';
import { HistoryPage } from '@/app/aulas/HistoryPage';

export const Route = createFileRoute('/_app/cursos/_painel/historico')({
  component: HistoryPage,
});
